<template>
    <v-form
            class="project-diary-form"
            :class="{'project-diary-form_mobile': $vuetify.breakpoint.xsOnly}"
    >
        <v-textarea
            v-model="value.msg"
            outlined
            dense
            hide-details="auto"
            data-vv-name="msg"
            :error-messages="errors.collect('msg')"
            v-validate="'required'"
        ></v-textarea>
        <!--<input-file
                v-model="value.images"
                :error-messages="errors.collect('images')"
                data-vv-name="images"
                btn-label="msg.addImages"
                type="image"
                :item-width="150"
                multiple
                class="mt-3"
        ></input-file>-->
        <btns-wrap class="mt-2">
            <v-btn
                color="secondary"
                :small="!isMobile"
                :style="{
                    'color': colorPrimary
                }"
                @click="closeForm()"
                :loading="loading"
                elevation="0"
            >{{ $t('msg.cancel') }}</v-btn>
            <v-btn
                color="primary"
                class="ml-2"
                :small="!isMobile"
                @click="sendForm()"
                :loading="loading"
                elevation="0"
            >{{ $t('msg.send') }}</v-btn>
        </btns-wrap>
    </v-form>
</template>

<script>
import InputFile from "../../ui/InputFile";
import BtnsWrap from "../../ui/BtnsWrap";

export default {
    components: {InputFile, BtnsWrap},
    props: {
        value: Object,
        index: Number,
        targetId: Number,
        targetDairyId: Number
    },
    data() {
        return {
            loading: false
        };
    },
    watch: {
        value: {
            handler(v) {
                this.$emit('input', v);
            },
            deep: true
        }
    },
    computed: {
        colorPrimary() {
            return process.env.VUE_APP_COLOR_PRIMARY_DARK;
        }
    },
    methods: {
        closeForm(index) {
            this.$emit('close-form')
        },
        sendForm(index) {

            this.$validator.validateAll()
                .then(res => {
                    if (res) {

                        this.loading = true;

                        this.value.time_zone = this.$store.state.user.timeZone;

                        let action = this.value.id === null ? 'createTargetDairy' : 'updateTargetDairy';
                        this.$store.dispatch(action, {
                            id: this.targetId,
                            subId: this.targetDairyId,
                            subSubId: this.value.id,
                            data: this.value
                        })
                            .then(res => {
                                this.value.id = res.id;
                                this.value.date = res.date;
                                this.indexOpenForm = null;
                                this.$emit('added');
                            })
                            .finally(() => this.loading = false);
                    }
                });
        }
    }
}
</script>

<style lang="scss">
    .project-diary-form {
        &.project-diary-form_mobile {
            .input-file {
                .input-file__btn {
                    width: 100%;
                }
            }
        }
    }
</style>